import React from 'react';
import { motion } from 'framer-motion';

const Warranty = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <div className="min-h-screen bg-dark-400 pt-24 pb-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-futuristic font-bold mb-6">
            <span className="gradient-text">🛡 Warranty Policy</span>
          </h1>
        </motion.div>

        {/* Warranty Policy Section */}
        <motion.section
          className="mb-16"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div
            className="card-glass p-8 rounded-lg max-w-4xl mx-auto"
            variants={itemVariants}
          >
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>Only selected products include a limited warranty.</p>
              <p>Warranty coverage (if applicable) will be clearly stated on the product page.</p>
              <p>Standard warranty period: <span className="text-primary-400 font-semibold">3–5 days</span> functional guarantee from delivery date.</p>
              <p>Items without warranty will still be tested before shipping.</p>
            </div>
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default Warranty;
